export const isClient = () => import.meta.client;
